function setSwatches() {
  const matchSwatches = document.querySelectorAll("[data-bgcolor]");
  [].forEach.call(matchSwatches, function(label) {
    // replace the bg color
    label.style.backgroundColor = window.assets.swatches[label.getAttribute('data-bgcolor')];
  });
}
function loadScript(options = {}) {
  if (!options.type) {
    options.type = 'json';
  }
  return window
    .fetch(options.json)
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      return response;
  });
}

async function getSwatchesArr() {
  const getColors = await loadScript({ json: window.assets.swatches });
  window.assets.swatches = getColors;
}


document.addEventListener("DOMContentLoaded", function(event) {
  getSwatchesArr().then((response) => {
    setSwatches();
  });
});
